import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImportNPIDialogComponent from './ImportNPIDialog';
import { createStringDataField } from '../../../../util/format/index';
import { setV2 } from '../../../../store/actions/pagesV2';
import { setMulti } from '../../../../store/actions/pages';

const PAGE_NAME = 'facility-npi-import';

const fields = [
    createStringDataField('billingProviderNPI', 'Billing Provider NPI', { sortable: true }),
    createStringDataField('providerCCN', 'Provider CCN', { sortable: true }),
];

export const ImportNPIDialog = connect(
    (state: any) => ({
        fields,
        selectedItems: state.pagesV2[PAGE_NAME]?.selected || [],
        pageName: PAGE_NAME,
    }),
    (dispatch) => ({
        actions: bindActionCreators({
            setCheckboxSelected: (value) => setV2(PAGE_NAME, 'selected', value),
            setMulti: (pageName, values) => setMulti(pageName, values),
        }, dispatch)
    })
)(ImportNPIDialogComponent);
